/* global globalThis */
import React from 'react';
import PropTypes from 'prop-types';
import QuestionBox from "./QuestionBox/QuestionBox";
import QuizFooter from "./QuizFooter/QuizFooter";
import { useSelector } from "react-redux";

/**
 * Question box with footer
 * @param props
 * @returns {*}
 * @constructor
 */
const QuestionPlayground = props => {
    const {
        mode, isLoading, drawerToggle, viewMode, slug, handleClick, toggleClick, handlerOpenCheckScore,
        handleQuizPauseChange, pauseQuiz, setPauseQuiz, reset, setReset, directionData, directionId
    } = props;
    const total = useSelector((state) => state.quiz.totalQuestions);
    const activeQuestionIndex = useSelector((state) => state.activeQuestionIndex);
    return (
        <React.Fragment>
            <QuestionBox mode={mode} isLoading={isLoading}
                         drawerToggle={drawerToggle}
                         viewMode={viewMode}
                         directionData={directionData}
                         directionId={directionId}
                         slug={slug}
                         activeQuestionIndex={activeQuestionIndex}
                         handleClick={toggleClick}
                         total={total}
                         pauseQuiz = {pauseQuiz}
                         setPauseQuiz = {setPauseQuiz}
                         handleQuizPauseChange = {handleQuizPauseChange}
                         number={activeQuestionIndex + 1}/>
            <QuizFooter mode={mode} viewMode={viewMode} hideNext={activeQuestionIndex === (total - 1)}
                        drawerToggle={drawerToggle}
                        handlerOpenCheckScore={handlerOpenCheckScore}
                        hidePrev={activeQuestionIndex === 0}
                        handleClick={handleClick}
                        reset={reset}
                        setReset={setReset}
                        activeQuestionIndex={activeQuestionIndex}
                        handleQuizPauseChange={handleQuizPauseChange}/>
        </React.Fragment>
    );
};

QuestionPlayground.propTypes = {
    mode: PropTypes.string,
    isLoading: PropTypes.bool,
    drawerToggle: PropTypes.bool,
    viewMode: PropTypes.bool,
    slug: PropTypes.string,
    handleClick: PropTypes.func,
    toggleClick: PropTypes.func,
    handlerOpenCheckScore: PropTypes.func,
    handleQuizPauseChange: PropTypes.func,
    pauseQuiz: PropTypes.bool,
    setPauseQuiz: PropTypes.func,
    reset: PropTypes.bool,
    setReset: PropTypes.func,
    directionData: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    directionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default QuestionPlayground;
